users.directive('isTest', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: false,
        template:'<i class="fa fa-warning" title="Techniczne"></i>',
        link: function(scope) { }
    }
});